import React from "react";
import DotLegalDeleteDialogWrapper from "@common/components/dotLegalDeleteDialog/DotLegalDeleteDialogWrapper";
import { RiskAreaSaveModel } from "../riskAreaDialog/RiskAreaDialog.types";
import { DeleteRiskAreaDialogDataMapping } from "./DeleteRiskAreaDialog.hooks";

export interface IDeleteRiskAreaDialog {
    onCloseDialog: () => void;
    onDeletion: () => void;
    riskAreaId: string;
    riskAreaName: string;
}

export function DeleteRiskAreaDialog(props: IDeleteRiskAreaDialog) {
    const { removeRiskArea, inProgress } = DeleteRiskAreaDialogDataMapping(props);

    return (
        <DotLegalDeleteDialogWrapper
            open
            itemForDeletion={props.riskAreaName}
            onDialogClose={props.onCloseDialog}
            onOkClick={removeRiskArea}
            inProgress={inProgress}
        />
    );
}
